/* @flow */

import * as React from 'react';
import { useIntl } from 'react-intl';
import { Title, Meta } from 'react-head';

import useEventBraindateName from 'src/shared/domain/event/hook/useEventBraindateName';
import { areTitleWordsCapitalized } from 'src/shared/app/locale/settings/localeSettings';
import { capitalize, capitalizeWords } from 'src/shared/core/util/stringUtil';

type Props = {
  children?: string,
};

const DocumentTitle = ({ children }: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */
  const { braindatePlatform } = useEventBraindateName();
  const { locale } = useIntl();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */
  const pageText =
    children &&
    (areTitleWordsCapitalized(locale)
      ? capitalizeWords(children)
      : capitalize(children));
  // Don'T compute this in JSX because SSR adds weird tags
  const text = pageText
    ? `${pageText} - ${braindatePlatform}`
    : braindatePlatform;

  return (
    <React.Fragment>
      <Title>{text}</Title>
      <Meta name="og:title" content={text} />
      <Meta name="twitter:title" content={text} />
    </React.Fragment>
  );
};

export default React.memo<Props>(DocumentTitle);
